import Button from '@atlaskit/button';
import { useInteractiveBoardStore } from './state';
import RefreshIcon from '@atlaskit/icon/glyph/refresh';
import {
  rotateRestartButtonStyle,
  fadeInRestartButtonStyle
} from './jsw-interactive-board.styles';

export const RestartButton = () => {
  const [{ messages, isDemoComplete }, { restartDemo }] =
    useInteractiveBoardStore();
  const { restartDemo: restartDemoString = '' } = messages;

  const clickHandler = () => {
    void restartDemo();
  };

  return (
    <Button
      appearance="subtle-link"
      onClick={clickHandler}
      iconAfter={<RefreshIcon label="" />}
      isDisabled={!isDemoComplete}
      css={[rotateRestartButtonStyle, fadeInRestartButtonStyle]}
    >
      {restartDemoString}
    </Button>
  );
};
